import TableListProductMapping from '@pages/UploadMappingV2/components/Table/TableListProductMapping';
import { useMassalStore } from '@pages/UploadMappingV2/hooks/state/useAddProductMassal';
import { tableHeadLists, tableHeadListsConnect } from './const';
import EmptyState from '@pages/UploadMappingV2/components/ui/EmptyState';
import { EmptyStateProductMapping } from '@pages/UploadMappingV2/assets/images';

export default function ProductBundle() {
    const { bundles } = useMassalStore();

    const renderContent =
        bundles.length > 0 ? (
            <TableListProductMapping
                isPagination
                tableHeadLists={tableHeadLists}
                tableData={bundles}
                data={bundles}
                isDefaultExpanded
                customExpandedTable={(row) => (
                    <TableListProductMapping
                        tableHeadLists={tableHeadListsConnect}
                        tableData={row.items}
                        data={row.items}
                    />
                )}
            />
        ) : (
            <EmptyState
                title="Tidak Ada Produk Untuk Di-mapping"
                description="Anda dapat melanjutkan ke proses berikutnya."
                Image={EmptyStateProductMapping}
            />
        );

    return renderContent;
}
